import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { API } from '../constants/api';
import { LocalStorageService } from './common/localstorage-service';
import { BaseApiService } from './common/base-api.service';
import { FirebaseMessagingService } from './firebase-messaging.service';

export interface LoginUserData {
  full_name: string;
  user_id: number;
  rvsf_id: number;
  email: string;
  rvsf_name: string;
  token: string;
  designation?: string;
  profile_picture_path?: string;
  /** Backend may send role as any of these when terms flow should run for administrators */
  role_name?: string;
  roleName?: string;
  role?: string;
  branches?: unknown[];
}

export interface LoginResponse {
  data: LoginUserData;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService,
    private baseApiService: BaseApiService,
    private firebaseMessagingService: FirebaseMessagingService,
  ) {}

  login(email: string, password: string): Observable<LoginResponse> {
    return this.http
      .post<LoginResponse>(API.auth.login, { email, password })
      .pipe(
        tap((res) => {
          this.localStorage.set('token', res.data.token);
          this.localStorage.set('user', res.data);
          this.generateAndSaveFcmToken();
        }),
      );
  }

  generateAndSaveFcmToken(): void {
    this.firebaseMessagingService
      .requestPermission()
      .then((fcmToken) => {
        if (fcmToken) {
          this.localStorage.set('current_firebase_token', fcmToken);
          this.updateFcmToken(fcmToken).subscribe();
        }
      })
      .catch(() => {});
  }

  updateFcmToken(fcmToken: string): Observable<any> {
    return this.baseApiService.post(API.auth.fireBaseToken, { fcmToken });
  }

  logout(): void {
    this.firebaseMessagingService.deleteToken().catch(() => {});
    this.localStorage.removeMultiple([
      'token',
      'user',
      'current_firebase_token',
    ]);
  }

  getToken(): string | null {
    return this.localStorage.get<string>('token');
  }

  getFcmToken(): string | null {
    return this.localStorage.get<string>('current_firebase_token');
  }

  getUser(): LoginUserData | null {
    return this.localStorage.get<LoginUserData>('user');
  }

  forgetPassword(payload: { email: string }): Observable<any> {
    return this.baseApiService.post(API.auth.forgetPassword, payload);
  }

  validateOtp(payload: { email: string; otp: number }): Observable<any> {
    return this.baseApiService.post(API.auth.validateotp, payload);
  }

  passwordReset(payload: {
    email: string;
    otp: number;
    password: string;
  }): Observable<any> {
    return this.baseApiService.post(API.auth.passReset, payload);
  }
  getProfile(): Observable<any> {
    return this.baseApiService.get(API.auth.profile);
  }
}
